import { TransferService } from './../../services/transfer.service';
import { Contact, UserStatus } from './../../model/contact';
import { Component, OnInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DistributorsService } from '../../services/distributors.service';
import { DcAlertService } from 'src/app/ui-kit/dc-alert/dc-alert.service';
import { PlatformLocation } from '@angular/common';
import { Distributor } from '../../model/distributor';

interface DropdownItem {
  id: string;
  displayValue: string;
}

@Component({
    selector: 'deltacapita-edit-distributor-contact',
    templateUrl: './edit-distributor-contact.component.html',
    styleUrls: ['./edit-distributor-contact.component.scss'],
    standalone: false
})
export class EditDistributorContactComponent implements OnInit {
  @Input() modal: NgbModalRef;
  @ViewChild('loadingSpinner', { static: true }) loadingSpinner: TemplateRef<any>;
  loading: boolean = true;

  editDistributorContactForm: UntypedFormGroup;
  contactToBeEdited: Contact;
  distributorsDropdownData: DropdownItem[];

  distributorContactStatusDropdownData: DropdownItem[] = [
    { id: UserStatus.active, displayValue: 'ACTIVE' },
    { id: UserStatus.notCreated, displayValue: 'NOT CREATED' },
    { id: UserStatus.notLoggedOnYet, displayValue: 'NOT LOGGED ON YET' },
  ];

  regionsDropdownData: DropdownItem[] = [
    {
      id: 'EMEA',
      displayValue: 'EMEA',
    },
    {
      id: 'APAC',
      displayValue: 'APAC',
    },
    {
      id: 'AMER',
      displayValue: 'AMER',
    },
  ];
  constructor(
    private distributorsService: DistributorsService,
    private dcAlertService: DcAlertService,
    private transferService: TransferService,
    location: PlatformLocation
  ) {
    location.onPopState((event) => {
      // ensure that modal is opened
      if (this.modal !== undefined) {
        this.modal.close();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.contactToBeEdited = this.transferService.getData();
    this.transferService.clearData();
    this.editDistributorContactForm = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      email: new UntypedFormControl(null, Validators.required),
      mobile: new UntypedFormControl(null),
      tel: new UntypedFormControl(null),
      distributors: new UntypedFormControl(null, Validators.required),
      region: new UntypedFormControl(null, Validators.required),
    });

    this.distributorsService.getAllDistributors().subscribe((distributors: Distributor[]) => {
      this.distributorsDropdownData = this.makeDropdownItems(distributors, 'id', 'name');
      this.loading = false;
    });

    this.editDistributorContactForm.patchValue(this.contactToBeEdited);

    this.loading = false;
  }

  async updateDistributorContact(): Promise<void> {
    const updatedDistributorContact = this.editDistributorContactForm.getRawValue();

    this.distributorsService.updateDistributorContact(this.contactToBeEdited.id, updatedDistributorContact).subscribe(
      (contact: Contact) => {
        this.dcAlertService.showAlert({
          type: 'success',
          message: `Successfully updated contact: ${contact.name}(${contact.email})`,
        });
        // this.distributorsService.refreshContactsSubject.next();
        this.transferService.notifyOther({ toRefresh: true, keysToRemove: ['contacts'] });

        this.modal.close();
      },
      (e) => {
        this.loading = false;
        console.log(e);
        this.dcAlertService.showAlert({
          type: 'danger',
          message: 'Error updating contact!',
        });
      }
    );
  }

  makeDropdownItems(data, idField, displayValueField): DropdownItem[] {
    return data.map((dataItem) => {
      return {
        id: dataItem[idField],
        displayValue: Array.isArray(displayValueField)
          ? `${dataItem[displayValueField[0]]} (${dataItem[displayValueField[1]]})`
          : dataItem[displayValueField],
      };
    });
  }
}
